import React, { useState, useCallback } from 'react';
import PropType from 'prop-types';
import injectSheet from 'react-jss';

import { RadioButton, AvatarGroup, Icon } from '@stratumn/atomic';

import styles from './groupActionsList.style';

export const GroupActionsList = React.memo(
  ({
    classes,
    groupActions,
    selectedLink,
    setSelectedLink,
    initDisplay,
    priority
  }) => {
    const [displayGroupActions, setDisplayGroupActions] = useState(initDisplay);

    const toggleDisplayGroupActions = useCallback(() => {
      setDisplayGroupActions(!displayGroupActions);
    }, [displayGroupActions]);

    // check if one of the actions is currently selected
    const selectedGroupAction =
      selectedLink.groupKey === groupActions.group.label
        ? groupActions.actions.find(
            action => selectedLink.actionKey === action.key
          )
        : undefined;

    const groupActionClassName = (group, action) => {
      if (
        group === priority.priorityGroupLabel &&
        action === priority.priorityActionKey
      ) {
        return classes.radioButtonSelected;
      }
      return classes.radioButton;
    };

    return (
      <div className={classes.groupActions}>
        {!displayGroupActions && selectedGroupAction && (
          <div className={classes.groupActionsSelectedIndicator} />
        )}
        <div
          data-cy="groupHeader"
          className={classes.groupHeader}
          onClick={toggleDisplayGroupActions}
        >
          <div className={classes.groupHeaderLeft}>
            <div className={classes.groupAvatarContainer}>
              <AvatarGroup size={35} src={groupActions.group.avatar} />
            </div>
            <div
              className={classes.groupKey}
            >{`As a member of ${groupActions.group.name}`}</div>
          </div>
          <div className={classes.groupHeaderRight}>
            {`${groupActions.actions.length} action${
              groupActions.actions.length > 1 ? 's' : ''
            }`}
            <div className={classes.groupActionsToggleIcon}>
              <Icon
                size={10}
                name={displayGroupActions ? 'ArrowDownFill' : 'ArrowDown'}
              />
            </div>
          </div>
        </div>
        <div
          className={classes.actionsWrapper}
          data-is-visible={displayGroupActions}
        >
          {groupActions.actions.map(action => (
            <div
              key={action.key}
              className={groupActionClassName(
                groupActions.group.label,
                action.key
              )}
            >
              <RadioButton
                dataCy="select"
                showLabel
                label={action.title}
                value={action.key}
                checked={
                  selectedGroupAction && selectedGroupAction.key === action.key
                }
                handleChange={() =>
                  setSelectedLink({
                    groupKey: groupActions.group.label,
                    actionKey: action.key
                  })
                }
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
);

GroupActionsList.propTypes = {
  classes: PropType.object.isRequired,
  groupActions: PropType.object.isRequired,
  selectedLink: PropType.object.isRequired,
  setSelectedLink: PropType.func.isRequired,
  initDisplay: PropType.bool.isRequired,
  priority: PropType.object.isRequired
};

GroupActionsList.defaultProps = {};

export default injectSheet(styles)(GroupActionsList);
